import { useMediaQuery } from "react-responsive";

export const SimpleCard = (props) => {
  const { title, subTitle } = props || {};
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });

  return (
    <div
      className={`flex-1 border rounded-lg shadow-100 flex flex-col items-center p-6 ${
        isMobile ? "w-auto" : ""
      } bg-white rounded-xl`}
    >
      <span className="font-medium text-base text-gray-700 mb-2">{title}</span>
      <span className="font-semibold text-2xl text-gray-900">{subTitle}</span>
    </div>
  );
};
